import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ChargeData {
  selected: boolean;
  type_code: string;
  type_label: string;
  type_value: number;
}

@Component({
  selector: 'app-charge-selector',
  templateUrl: './charge-selector.component.html',
  styleUrls: ['./charge-selector.component.css'],
})
export class ChargeSelectorComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<ChargeData>();
  displayedColumns = ['select', 'type_label', 'type_value'];
  selection = new SelectionModel<any>(true, []);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      chargesSelected: ChargeData[];
      chargesData: ChargeData[];
    },
    private dialogRef: MatDialogRef<ChargeSelectorComponent>
  ) {}

  ngOnInit(): void {
    this.data.chargesData.forEach(row => {
      row.selected = false;
    });
    this.data.chargesSelected.forEach(row => {
      let datarow = this.data.chargesData.find(r => r.type_code == row.type_code);
      datarow.selected = true;
      datarow.type_value = row.type_value;
      this.selection.select(datarow);
    });

    this.data.chargesData.filter(row => !row.selected).forEach(row => (row.type_value = 0));

    this.dataSource.data = this.data.chargesData;

    this.selection.changed.subscribe(s => {
      s.added.forEach(d => {
        d.selected = true;
      });
      s.removed.forEach(d => {
        d.selected = false;
        d.type_value = 0;
      });
    });
  }

  isAllSelected() {
    return this.dataSource.data.every(row => this.selection.isSelected(row));
  }
  selectAll() {
    this.dataSource.data.every(row => {
      row.selected = true;
    });
    this.selection.select(...this.dataSource.data);
  }

  desellectAll() {
    this.dataSource.data.every(row => {
      row.selected = false;
    });
    this.selection.deselect(...this.dataSource.data);
  }
  toggleAllRows() {
    this.isAllSelected() ? this.desellectAll() : this.selectAll();
  }

  closeDialog() {
    let selected = this.dataSource.data.filter(d => d.selected == true && d.type_value > 0);
    this.dialogRef.close({ data: selected });
  }
}
